export default "__VITE_ASSET__BiexIOcr__"